<template>
  <div>
    <b-modal
      :size="
        idCreate == 'finance_configuration_category' ||
        idCreate == 'finance_configuration_account'
          ? 'lg'
          : 'md'
      "
      no-close-on-backdrop
      hide-footer
      id="idCreate"
      :title="titleModalIdCreate"
    >
      <NewAccount
        v-if="idCreate == 'finance_configuration_account'"
        @success="handleSuccessAccount"
      />
      <NewCategory
        v-if="idCreate == 'finance_configuration_category'"
        @success="handleSuccessCategory"
      />
      <NewProfitCostCenter
        v-if="idCreate == 'finance_configuration_profit_cost_center'"
        @success="handleSuccessProfitCostCenter"
      />
      <ModalIdCreate
        v-if="
          idCreate != 'finance_configuration_account' &&
          idCreate != 'finance_configuration_category' &&
          idCreate != 'finance_configuration_profit_cost_center'
        "
        :id="idCreate"
        @success="handleSuccessIdCreate"
        @cancel="$bvModal.hide('idCreate')"
      />
    </b-modal>
    <div class="row">
      <div class="col-auto" v-if="vModel.launchValue">
        <h4 class="title-pages">R$ {{ vModel.launchValue }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-end">
          <v-autocomplete-default
            style="width: 100%"
            alternative-label
            label="FORNECEDOR"
            item-text="company_name"
            item-value="id"
            :items="providers"
            v-model="vModel.providerId"
          />
          <v-btn-add
            class="mb-1 ml-2"
            text="NOVO"
            @click="$bvModal.show('new_provider')"
          />
        </div>
        <h6 v-if="providerWithoutCnpj" class="text-danger">
          FORNECEDOR SEM CNPJ!
        </h6>
      </div>
      <div class="col">
        <v-text-field-default
          alternative-label
          label="DESCRIÇÃO"
          required
          v-model="vModel.description"
        />
      </div>
      <div class="col">
        <div class="d-flex align-items-end">
          <v-autocomplete-default
            style="width: 100%"
            alternative-label
            label="CATEGORIA"
            :items="cFinanceConfigurationCategories"
            item-text="text"
            item-value="id"
            v-model="vModel.financeConfigurationCategoryId"
          />
          <v-btn
            class="btn-add mb-1 ml-2"
            @click="handleIdModalCreate('finance_configuration_category')"
            ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-end">
          <v-autocomplete-default
            style="width: 100%"
            alternative-label
            label="CENTRO DE CUSTO/LUCRO"
            item-text="description"
            item-value="id"
            :items="cFinanceConfigurationProfitCostCenter"
            v-model="vModel.financeConfigurationProfitCostCenterId"
          />
          <v-btn
            class="btn-add mb-1 ml-2"
            @click="
              handleIdModalCreate('finance_configuration_profit_cost_center')
            "
            ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
          >
        </div>
      </div>
      <div class="col">
        <div class="d-flex align-items-end">
          <v-autocomplete-default
            style="width: 100%"
            alternative-label
            label="FORMA DE PAGAMENTO"
            :items="cFinanceConfigurationPaymentMethods"
            item-text="description"
            item-value="id"
            v-model="vModel.financeConfigurationPaymentMethodId"
          />
          <v-btn
            class="btn-add mb-1 ml-2"
            @click="
              handleIdModalCreate('finance_configuration_payment_methods')
            "
            ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
          >
        </div>
      </div>
      <div class="col">
        <div class="d-flex align-items-end">
          <v-autocomplete-default
            style="width: 100%"
            alternative-label
            label="TAGS"
            chips
            multiple
            item-text="description"
            item-value="id"
            :items="financeConfigurationTags"
            v-model="vModel.financeConfigurationTagIds"
          />
          <v-btn
            class="btn-add mb-1 ml-2"
            @click="handleIdModalCreate('finance_configuration_tag')"
            ><i class="fas fa-plus mr-2"></i> NOVA
          </v-btn>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <v-autocomplete-default
          alternative-label
          label="TIPO DE CUSTO"
          :items="costTypes"
          item-text="description"
          item-value="value"
          v-model="vModel.costTypeValue"
        />
      </div>
      <div class="col">
        <v-autocomplete-default
          alternative-label
          label="APROPRIAÇÃO DE CUSTO"
          :items="costAppropriations"
          item-text="description"
          item-value="value"
          v-model="vModel.costAppropriationValue"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr />
        <h4 class="title-pages">FINANCEIRO</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <v-text-field-default
          alternative-label
          label="VALOR DO LANÇAMENTO"
          v-model="vModel.launchValue"
          @input="handleValue"
        />
      </div>
      <div class="col-auto">
        <v-autocomplete-default
          alternative-label
          label="NA CONTA"
          :items="cFinanceConfigurationAccount"
          item-value="id"
          item-text="text"
          required
          v-model="vModel.financeConfigurationAccountId"
        />
      </div>
      <div class="col-auto">
        <v-text-field-default
          alternative-label
          :label="
            vModel.paymentStatus === 'not_paid' ? 'VENCIMENTO' : 'PAGO EM'
          "
          type="date"
          v-model="vModel.dueDatePaymentDate"
        />
      </div>
    </div>
    <hr />
    <!-- Anexos -->
    <div class="row m-0">
      <div class="col border">
        <label> ANEXOS </label>
        <v-data-table-default
          no-data-text="NENHUM ANEXO ADICIONADO"
          hide-default-footer
          :headers="attachmentsHeaders"
          :items="vModel.attachments"
          :showNoData="false"
        >
          <template v-slot:[`item.action`]="{ item }">
            <confirmation-dialog
              x_small
              message-title="REMOVER?"
              message-body="Deseja realmente remover o item?"
              open-class="btn-delete"
              open-left-icon="fa-trash"
              open-text="REMOVER"
              @yes="removeAttachment(item)"
            />
          </template>
        </v-data-table-default>
        <div class="row no-gutters justify-end">
          <div class="col-auto">
            <small class="font-weight-bold">
              {{ vModel.attachments.length }} / 10
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="attachmentErrors.length > 0">
      <div class="col">
        <errors-messages :errors="attachmentErrors" />
      </div>
    </div>
    <div class="row">
      <div class="col d-flex">
        <small class="d-block font-weight-bold mr-2">Até 10 anexos.</small>
        <small class="d-block font-weight-bold mr-2"
          >Tamanho máximo 10MB.</small
        >
        <small class="d-block font-weight-bold"
          >Formatos: PDF, JPG, JPEG, PJPEG e PNG.</small
        >
      </div>
      <div class="col-auto">
        <input
          class="d-none"
          type="file"
          id="attachment-input"
          multiple
          accept=".png, .jpg, .jpeg, .xml, .pdf"
          @change="evOnAttachmentSelected"
        />
        <v-btn-import
          :disabled="btnAddAttachmentDisabled"
          @click="addAttachment"
          text="ANEXAR"
        />
      </div>
    </div>
    <hr />
    <!-- opções -->
    <div class="row">
      <div class="col">
        <v-text-field-default
          alternative-label
          type="date"
          label="COMPETÊNCIA"
          v-model="vModel.competence"
        />
      </div>
      <div class="col">
        <div class="d-flex align-items-end">
          <v-autocomplete-default
            style="width: 100%"
            alternative-label
            label="TIPO DE DOCUMENTO"
            item-text="description"
            item-value="id"
            :items="cFinanceConfigurationDocumentTypes"
            v-model="vModel.financeConfigurationDocumentTypeId"
          />
          <v-btn
            class="btn-add mb-1 ml-2"
            @click="handleIdModalCreate('finance_configuration_document_types')"
            ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
          >
        </div>
      </div>
      <div class="col">
        <v-text-field-default
          alternative-label
          label="Nº DOCUMENTO"
          v-model="vModel.documentNumber"
        />
      </div>
      <div class="col">
        <chrome-speech-to-text-textarea
          label="OBSERVAÇÕES"
          rows="3"
          v-model="vModel.note"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VAutocompleteDefault from "../../../Components/VAutocompleteDefault.vue";
import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";
import VDataTableDefault from "../../../Components/VDataTableDefault.vue";
import VBtnImport from "../../../Components/VBtnImport.vue";
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea.vue";
import VBtnAdd from "../../../Components/VBtnAdd.vue";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import ModalIdCreate from "../../../Financial/Releases/SpentGain/ModalIdCreate";

import NewAccount from "../../../Financial/Configuration/Accounts/Create";
import NewCategory from "../../../Financial/Configuration/Categories/Create";
import NewProfitCostCenter from "../../../Financial/Configuration/CostProfitCenter/Create";

import { getRestHomeSelectedFinancialAccount } from "../../../../lib/functions";

import {
  formatFileSize,
  formatReal,
  formatValueOnKeyUp,
  numbersOnly,
} from "../../../../lib/format";

import moment from "moment";

import APIGet from "../../../../lib/api-get";

import api from "../../../../services/api";

export default {
  name: "Financial",

  components: {
    VAutocompleteDefault,
    VTextFieldDefault,
    VDataTableDefault,
    VBtnImport,
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
    VBtnAdd,
    ConfirmationDialog,
    ModalIdCreate,
    NewAccount,
    NewCategory,
    NewProfitCostCenter,
  },

  props: {
    refreshProviders: { type: Boolean },
    providerId: { type: Number },
  },

  data() {
    return {
      errors: [],
      attachmentErrors: [],
      loading: false,

      /**
       * página
       */

      financeConfigurationAccount: [],
      paymentsInterval: [
        "SEMANAL",
        "QUINZENAL",
        "MENSAL",
        "BIMESTRAL",
        "TRIMESTRAL",
        "SEMESTRAL",
        "ANUAL",
      ],
      financeConfigurationCategories: [],
      financeConfigurationProfitCostCenter: [],
      providers: [],
      financeConfigurationPaymentMethods: [],
      financeConfigurationTags: [],
      costTypes: [
        // { description: "SELECIONE", value: null },
        { description: "FIXO", value: "FIXO" },
        { description: "VARIÁVEL", value: "VARIAVEL" },
      ],
      costAppropriations: [
        // { description: "SELECIONE", value: null },
        { description: "DIRETO", value: "DIRETO" },
        { description: "INDIRETO", value: "INDIRETO" },
      ],
      attachmentsHeaders: [
        { text: "Nome", value: "name" },
        { text: "Tamanho", value: "size" },
        { text: "Ação", value: "action" },
      ],
      financeConfigurationDocumentTypes: [],

      vModel: {
        launchValue: "",
        additionalLaunchings: [],
        /**
         * @type {("paid"|"not_paid")}
         */
        paymentStatus: "not_paid",
        financeConfigurationAccountId: null,
        dueDatePaymentDate: moment().format("YYYY-MM-DD"),
        isPaid: false,
        paymentDate: moment().format("YYYY-MM-DD"),
        repeatPayment: false,
        paymentInterval: "MENSAL",
        repeatPaymentAmount: "",
        description: "",
        financeConfigurationCategoryId: null,
        financeConfigurationProfitCostCenterId: null,
        providerId: null,
        financeConfigurationPaymentMethodId: null,
        financeConfigurationTagIds: [],
        costTypeValue: null,
        costAppropriationValue: null,
        /**
         * @type {{
         *   name: string,
         *   file: File,
         * }[]}
         */
        attachments: [],
        note: "",
        competence: "",
        financeConfigurationDocumentTypeId: null,
        documentNumber: "",
      },

      idCreate: "",
      titleModalIdCreate: "",
    };
  },

  computed: {
    /**
     * getters
     */

    cFinanceConfigurationAccount() {
      return [
        ...this.financeConfigurationAccount.map((account) => ({
          ...account,
          text: account.finance_configuration_grouping_description
            ? `${account.finance_configuration_grouping_description} / ${account.account_nickname}`
            : `${account.account_nickname}`,
        })),
      ];
    },

    cFinanceConfigurationCategories() {
      return [
        ...this.financeConfigurationCategories.map((category) => ({
          ...category,
          text: category.parent
            ? `${category.parent.name} / ${category.name}`
            : category.name,
        })),
      ];
    },

    cFinanceConfigurationProfitCostCenter() {
      return [
        // {
        //   id: null,
        //   description: "SELECIONE",
        // },
        ...this.financeConfigurationProfitCostCenter,
      ];
    },

    cFinanceConfigurationPaymentMethods() {
      return [
        // { id: null, description: "SELECIONE" },
        ...this.financeConfigurationPaymentMethods,
      ];
    },

    cFinanceConfigurationDocumentTypes() {
      return [
        // { id: null, description: "SELECIONE" },
        ...this.financeConfigurationDocumentTypes,
      ];
    },

    /**
     * anexos
     */

    attachmentInput() {
      return document.getElementById("attachment-input");
    },

    btnAddAttachmentDisabled() {
      if (this.vModel.attachments.length >= 10) return true;

      return false;
    },

    /**
     * estados
     */

    providerWithoutCnpj() {
      const provider = this.providers.find(
        (provider) => provider.id == this.vModel.providerId
      );

      return numbersOnly(provider?.cpf_cnpj ?? "").length !== 14;
    },
  },

  watch: {
    vModel: {
      handler: function () {
        this.$emit("input", this.vModel);
      },
      deep: true,
    },

    refreshProviders() {
      this.getProviders().then();
    },

    async providerId(id) {
      if (id) {
        await this.getProviders();
        this.vModel.providerId = id;
      }
    },
  },

  created() {
    this.$emit("input", this.vModel);
    this.retrieve().then();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,
    formatReal,

    async handleSuccessAccount(id) {
      this.$bvModal.hide("idCreate");
      await this.getFinanceConfigurationAccount();
      this.vModel.financeConfigurationAccountId = id[0];
    },

    async handleSuccessCategory(id) {
      this.$bvModal.hide("idCreate");
      await this.getFinanceConfigurationCategories();
      this.vModel.financeConfigurationCategoryId = id[0];
    },

    async handleSuccessProfitCostCenter(id) {
      this.$bvModal.hide("idCreate");
      await this.getFinanceConfigurationProfitCostCenter();
      this.vModel.financeConfigurationProfitCostCenterId = id[0];
    },

    async handleSuccessProvider(id) {
      this.$bvModal.hide("new_provider");
      await this.getProviders();
      this.vModel.providerId = id;
    },

    handleIdModalCreate(id) {
      if (id) {
        let titleModalIdCreate =
          {
            finance_configuration_account: "NOVA CONTA",
            finance_configuration_category: "NOVA CATEGORIA",
            finance_configuration_profit_cost_center:
              "NOVO CENTRO DE CUSTO/LUCRO",
            provider: "NOVO FORNECEDOR",
            finance_client: "NOVO CLIENTE",
            finance_configuration_payment_methods: "NOVA FORMA DE PAGAMENTO",
            finance_configuration_tag: "NOVA TAG",
            finance_configuration_document_types: "NOVO TIPO DE DOCUMENTO",
          }[id] || "";

        this.titleModalIdCreate = titleModalIdCreate;
        this.idCreate = id;
        if (id == "provider") {
          this.$bvModal.show("new_provider");
        } else {
          this.$bvModal.show("idCreate");
        }
      }
    },

    async handleSuccessIdCreate({ type, id }) {
      this.$bvModal.hide("idCreate");

      if (type == "provider") {
        await this.getProviders();
        this.vModel.providerId = id;
      }

      if (type == "finance_configuration_payment_methods") {
        await this.getFinanceConfigurationPaymentMethods();
        this.vModel.financeConfigurationPaymentMethodId = id[0];
      }

      if (type == "finance_configuration_tag") {
        await this.getFinanceConfigurationTags();
        this.vModel.financeConfigurationTagIds = id;
      }

      if (type == "finance_configuration_document_types") {
        await this.getFinanceConfigurationDocumentTypes();
        this.vModel.financeConfigurationDocumentTypeId = id[0];
      }
    },

    handleValue(value) {
      this.vModel.launchValue = formatValueOnKeyUp(String(value));
    },

    removeAttachment(item) {
      const index = this.vModel.attachments.findIndex(
        (attachment) => attachment === item
      );
      this.vModel.attachments.splice(index, 1);
    },

    //#region retrievers
    async retrieve() {
      if (this.errors.length === 0) await this.getFinanceConfigurationAccount();
      if (this.errors.length === 0) await this.getFinanceConfigurationTags();
      if (this.errors.length === 0)
        await this.getFinanceConfigurationCategories();
      if (this.errors.length === 0) await this.getProviders();
      if (this.errors.length === 0)
        await this.getFinanceConfigurationProfitCostCenter();
      if (this.errors.length === 0)
        await this.getFinanceConfigurationPaymentMethods();
      if (this.errors.length === 0)
        await this.getFinanceConfigurationDocumentTypes();
    },

    async getFinanceConfigurationAccount() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/account-actives",
          {
            params,
          }
        );

        const { errors, data } = response.data;

        this.errors = errors ?? [];
        this.financeConfigurationAccount = data ?? [];
        let noAccount = data.find((account) => account.default == 1);
        if (noAccount) {
          this.vModel.financeConfigurationAccountId = noAccount.id;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getFinanceConfigurationTags() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/tags-actives",
          {
            params,
          }
        );

        const { errors, data } = response.data;
        this.errors = errors ?? [];
        this.financeConfigurationTags = data ?? [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getFinanceConfigurationCategories() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          {
            params,
          }
        );

        const { errors, data } = response.data;

        this.errors = errors ?? [];
        this.financeConfigurationCategories = data ?? [];
        let noCategory = data.find((category) => category.default == 1);
        if (noCategory) {
          this.vModel.financeConfigurationCategoryId = noCategory.id;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getProviders() {
      try {
        this.loading = true;

        const { errors, providers } = await APIGet.getProviders();
        this.errors = errors;
        this.providers = providers ?? [];
        this.$emit("providersRefreshed", { providers: this.providers });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getFinanceConfigurationProfitCostCenter() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives",
          {
            params,
          }
        );

        const { errors, data } = response.data;

        this.errors = errors ?? [];
        this.financeConfigurationProfitCostCenter = data ?? [];
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getFinanceConfigurationPaymentMethods() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives",
          {
            params,
          }
        );

        const { errors, data } = response.data;

        this.errors = errors ?? [];
        this.financeConfigurationPaymentMethods = data ?? [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getFinanceConfigurationDocumentTypes() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives",
          {
            params,
          }
        );

        const { errors, data } = response.data;

        this.errors = errors ?? [];
        this.financeConfigurationDocumentTypes = data ?? [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    //#endregion

    //#region funcional
    addAttachment() {
      this.attachmentInput.click();
    },

    async evOnAttachmentSelected() {
      try {
        this.attachmentErrors = [];

        const files = this.attachmentInput.files;
        if (this.vModel.attachments.length + files.length > 10) {
          this.attachmentErrors.push("Limite de anexos atingido (máximo 10)");
          return;
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          this.vModel.attachments.push({
            index: this.vModel.attachments.length + 1,
            name: file.name,
            size: formatFileSize(file.size),
            file,
          });
        }
      } catch {
        // ...
      } finally {
        this.attachmentInput.value = null;
      }
    },
    //#endregion
  },
};
</script>

<style>
</style>